import React from 'react';
import createReactClass from 'create-react-class';
import PropTypes from 'prop-types';

import { withContainer } from 'core/cache';

import { cachePT, getIdFromParams } from '@/exceed';

import getContentTypeFromParams from '../helpers/getContentTypeFromParams';
import { getDashboards } from '../helpers/getMockData';

import InsightsDashboards from '../components/insightsDashboards';

const InsightsDashboardsContainer = createReactClass({
  componentDidMount() {
    const { dashboards, ...props } = this.props;

    dashboards.setQuery({
      dashboardable_id: props.id ?? getIdFromParams(props),
      dashboardable_type: getContentTypeFromParams(props),
    });

    dashboards.fetch(); // manual fetch due to cache issues
  },

  componentWillUnmount() {
    this.props.dashboards.setQuery({});
  },

  render() {
    const { dashboards: { data, status }, ...props } = this.props;

    return (
      <InsightsDashboards
        dashboards={data}
        dashboardableId={getIdFromParams(props)}
        dashboardableType={getContentTypeFromParams(props)}
        isLoading={status !== 'success'}
      />
    );
  },
});

InsightsDashboardsContainer.propTypes = {
  dashboards: cachePT({ dataType: 'array' }).isRequired,
  id: PropTypes.number,
};

export default withContainer(InsightsDashboardsContainer, {
  cache: {
    dashboards: {
      getDependencies: () => [false],
      getMockedResponse: () => ({ data: getDashboards() }),
      initialData: [],
      isMocked: false,
      transform: ({ data }) => data.data,
      url: '/api/admin/dashboards',
    },
  },
  hasRouter: true,
});
